import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    container: {
      "& .MuiTabs-flexContainer": {
        borderBottom: `1px solid ${theme.palette.divider}`,
        gap: "12px",
      },
      "& .MuiTab-root": {
        minWidth: "128px",
        padding: "12px 4px",
      },
      "& .MuiTab-wrapper": {
        alignItems: "flex-start",
        fontSize: "16px",
        fontWeight: 600,
        color: theme.palette.text.disabled,
      },
      "& .PrivateTabIndicator-colorPrimary-201": {
        BackgroundColor: theme.palette.background.brand_solid,
      },
      "& .MuiTab-textColorPrimary.Mui-selected .MuiTab-wrapper": {
        color: theme.palette.text.brand_700 + " !important",
      },
    },
  };
});
